import { render, staticRenderFns } from "./editproductinfo.vue?vue&type=template&id=3484848f"
import script from "./editproductinfo.vue?vue&type=script&lang=js"
export * from "./editproductinfo.vue?vue&type=script&lang=js"
import style0 from "./editproductinfo.vue?vue&type=style&index=0&id=3484848f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports